export default __webpack_public_path__ + "static/media/fa-regular-400.75ec6f48.svg";